// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * ARCHAT — Gestor de instalación PWA (beforeinstallprompt)
 * Muestra botones "Instalar ArChat" cuando el navegador permite instalación.
 * Soporta múltiples puntos de montaje: #installAppBtn (LoginView) y [data-pwa-install] (cualquier componente).
 * No muestra CTA si ya está en modo standalone (app instalada).
 */

let deferredPrompt = null;
let promptAvailable = false;

/**
 * @returns {boolean} true si la app ya está corriendo como PWA instalada.
 */
export function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true ||
    document.referrer.includes('android-app://')
  );
}

/**
 * @returns {boolean} true si el prompt de instalación está disponible.
 */
export function isInstallAvailable() {
  if (isStandalone()) return false;
  return promptAvailable || !!deferredPrompt;
}

function showInstallButtons() {
  if (isStandalone()) return;
  const legacy = document.getElementById('installAppBtn');
  if (legacy) legacy.style.display = 'block';
  document.querySelectorAll('[data-pwa-install]').forEach((el) => {
    el.style.display = '';
  });
}

function hideInstallButtons() {
  const legacy = document.getElementById('installAppBtn');
  if (legacy) legacy.style.display = 'none';
  document.querySelectorAll('[data-pwa-install]').forEach((el) => {
    el.style.display = 'none';
  });
}

/**
 * Sincroniza visibilidad de todos los CTA install cuando un componente monta después del evento.
 */
export function syncInstallButtonVisibility() {
  if (isStandalone()) {
    hideInstallButtons();
    return;
  }
  if (promptAvailable || deferredPrompt) {
    showInstallButtons();
  } else {
    hideInstallButtons();
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    promptAvailable = true;
    try {
      console.info('[PWA_INSTALL_PROMPT]', {
        event: 'beforeinstallprompt',
        standalone: isStandalone(),
        timestamp: new Date().toISOString(),
      });
    } catch (_) {}
    showInstallButtons();
  });
  window.addEventListener('appinstalled', () => {
    try {
      console.info('[PWA_INSTALL_PROMPT]', { event: 'appinstalled' });
    } catch (_) {}
    deferredPrompt = null;
    promptAvailable = false;
    hideInstallButtons();
  });
}

/**
 * Lanza el prompt nativo de instalación PWA.
 * @returns {Promise<void>}
 */
export async function installApp() {
  if (!deferredPrompt) return;
  try {
    deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    console.info('[PWA_INSTALL_PROMPT]', { event: 'userChoice', outcome: choice?.outcome });
  } catch (err) {
    console.warn('[PWA_INSTALL_PROMPT]', { event: 'prompt_error', error: err?.message });
  }
  deferredPrompt = null;
  promptAvailable = false;
  hideInstallButtons();
}
